import React, { memo } from "react";
import { CCollapse } from "@coreui/react";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Info = memo(function Info({ data = {} }) {
  let { stores, locations, regions, users, reports } = data;

  if (Object.keys(data).length === 0) {
    return <LoadingAnimation />;
  }

  return (
    <>
      <CCollapse show>
        <div className="admin-organizations__expanded">
          <InfoItem item={stores} title="Stores" />
          <InfoItem item={locations} title="Locations" />
          <InfoItem item={regions} title="Regions" />
          <InfoItem item={users} title="Users" />
          <InfoItem item={reports} title="Reports" />
        </div>
      </CCollapse>
    </>
  );
});

const InfoItem = ({ item, title }) => {
  return (
    <div>
      <p>
        {title} ({item.length}):
      </p>
      {item.map((el) => (
        <div key={el}>{el}</div>
      ))}
    </div>
  );
};
